<template>
    <portal>
        <modal @close="showModal = false" v-if="showModal" :disableClose="true">
            <p
                class="mt-1 mb-3 text-3xl text-center tracking-tight leading-10 font-extrabold text-gray-900 sm:leading-none sm:text-5xl lg:text-4xl xl:text-5xl"
            >Re-Join Game?</p>

            <p
                class="my-4 text-center"
            >It looks like you're already playing a game! Want to dive back in?</p>

            <template #buttons>
                <div class="flex space-x-2">
                    <a
                        href="#"
                        @click.stop.prevent="showModal = false"
                        class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 text-base leading-6 font-medium text-gray-800 focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >No, I'm Done</a>
                    <a
                        :href="url"
                        class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-gray-800 text-base leading-6 font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >Yes, Let's Go!</a>
                </div>
            </template>
        </modal>
    </portal>
</template>

<script>
import { timing } from '@/util/animation';
import { Portal } from '@linusborg/vue-simple-portal';
import Modal from '@/components/Modal';

export default {
    props: ['url'],
    data() {
        return {
            showModal: false,
        };
    },
    components: {
        Portal,
        Modal,
    },
    mounted() {
        if (this.url) {
            this.showModal = true;
        }
    },
};
</script>

<style></style>
